import React from "react"
import Image from "../image";

const TwoByOneImageBlock = (props) => {

    const imageSrc = props.src ? props.src : '';
    
    let template = (<> </>);
    if (imageSrc) {
        template = (<>
            <li className="column is-12-mobile is-12-tablet is-12-desktop is-12-widescreen">
                <div>
                    <div className="img-tile-image">
                        <Image
                            sizes="(min-width: 1216px) 612px, (min-width: 1024px) 704px, (min-width: 768px) 900px, calc(200vw - 5rem)"
                            height={"966"}
                            width={"4922"}
                            crop={false}
                            url={imageSrc}
                            aspectRatio="8:3.1"
                            focalPoint={[0.5,0.5]}
                            altText={"alt-text"}
                        />
                    </div>
                </div>
            </li>
        </>)
    }
    return template;
}

export default TwoByOneImageBlock;

